import React from 'react';
import './CounselingRoom2.css';
import counseling2Img from './assets/counselling2.jpg';

const CounselingRoom2 = () => {
  return (
    <div className="counseling2-page">

      {/* Top Banner with Overlay */}
      <div className="counseling-banner">
        <img src={counseling2Img} alt="Counseling Room 2" className="banner-img" />
        <div className="overlay">
          <h1>Welcome to Counseling Room 2</h1>
          <p>Personalized wellness conversations designed to empower you with healthy lifestyle choices.</p>
        </div>
      </div>

      {/* Video Section */}
      <section className="video-section">
        <h2>🎥 What Happens in Counseling Room 2?</h2>
        <p>
          In this room, our nurse walks you through your results and provides key lifestyle advice 
          based on your health data.
        </p>
        <div className="video-wrapper">
          <video
            controls
            playsInline
            preload="metadata"
            className="nurse-video"
          >
            <source src="https://res.cloudinary.com/dfbgpqygq/video/upload/v1751308562/video2_yxqz5u.mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <h2>🧠 Frequently Asked Questions (FAQs)</h2>
        <ul className="faq-list">
          <li>
  <span className="faq-question">What happens in Counseling Room 2?</span><br />
  <span className="faq-answer">
    1. Explanation on the importance of measuring waist circumference and how to measure it accurately.<br />
    2. Education on causes of high cholesterol in the body.<br />
    3. Guidance on healthy foods that help prevent diabetes.<br />
    4. Illustration of what a balanced healthy plate should consist of.<br />
    5. Discussion on the causes and prevention of diabetic foot.
  </span>
</li>
          <li>
            <span className="faq-question">How long does the counseling session take?</span><br />
            <span className="faq-answer">Typically 10 to 15 minutes.</span>
          </li>
          <li>
            <span className="faq-question">Can I ask the nurse questions during the session?</span><br />
            <span className="faq-answer">Absolutely. You're encouraged to ask anything related to your health or results.</span>
          </li>
        </ul>
      </section>

    </div>
  );
};

export default CounselingRoom2;
